export default __webpack_public_path__ + "static/images/mac-app.1528b6b4.png";